import React from "react";

import useBook from "../../hooks/useBook";

import ArchiveCanvas from "../../shared_comp/ArchiveCanvas";
import SectionTitle from "../../shared_comp/SectionTitle";
import MainCanvas from "../../shared_comp/MainCanvas";

import NumeroList from "../../shared_comp/NumeroList";

const CatalogueMain = () => {
  const [received, setReceived] = React.useState(false)
  const [booksCatalogue, setBooksCatalogue] = React.useState<any>([])

  React.useEffect(()=>{
    const receiveData = async()=>{
      const res = await useBook.getBookList("catalogue");
      setBooksCatalogue(res.books)
      setReceived(true)
    }
    receiveData()
  },[])

  console.log("Catalogue", booksCatalogue)

  return (
    <ArchiveCanvas>
      <SectionTitle title="정부자료 / 조선제학교일람" />
      <MainCanvas>
        {received && (
          <NumeroList
            numerolist={booksCatalogue}
            sortoption={"numeration"}
            cat={"catalogue"} />
        )}
      </MainCanvas>
    </ArchiveCanvas>);
};
export default CatalogueMain;
